import { BankAccountsManager } from '@/features/hrm/employees/components/BankAccountsManager';
import { useCabinetBankAccounts } from '../queries';

/** My Space → Bank Accounts. Read-only: the employee sees the payout
 * destinations on file, which Finance/HR maintain — they can't edit them here
 * (changing a payout account mid-cycle could break the pay flow). */
export function CabinetBankAccountsPage() {
  const { data, isPending } = useCabinetBankAccounts();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Bank Accounts</h1>
        <p className="text-muted-foreground text-sm">
          Where you’re paid, on file with Finance/HR. To change these, contact them.
        </p>
      </div>

      <BankAccountsManager
        accounts={data?.results ?? []}
        isPending={isPending}
        canManage={false}
        emptyText="No bank accounts on file yet — Finance/HR will add them."
      />
    </div>
  );
}
